import { getElement } from 'src/utils/parserHTML';
import { useSelector } from 'react-redux';
import { State } from 'src/types';
import { useEffect, useMemo } from 'react';
import PostHeaderInfo from './postHeaderInfo';
import styled from 'styled-components';
import { titleLarge, titleMedium } from 'styles-js/mixins/typography';

export default function PostHeader() {
  const { title } = useSelector(({pages}: State) => pages.singlePost.post?.enriched);
  const parsedTitle = useMemo(() => getElement(title), [title]);

  useEffect(() => {
    const hash = location.hash?.replace('#', '');
    const position = document.getElementById('post-heading')?.offsetTop;
    if (hash === 'post_title' && !!position) {
      window.scrollTo({
        behavior: 'smooth',
        top: position - 52,
      });
    }
  }, []);

  return (
    <Header>
      <H1 id="post-heading">
        {parsedTitle}
      </H1>
      <PostHeaderInfo />
    </Header>
  );
}

const Header = styled.header`
  margin-bottom: 30px;
`;

const H1 = styled.h1`
  ${titleMedium}
  margin-top: 0;
  margin-bottom: 10px;
  overflow-wrap: break-word; // Partial support for IE11
  word-wrap: break-word; // IE11

  @media (${({theme}) => theme.overScreenSmall}) {
    ${titleLarge};
  }
`;
